import React, { useEffect, useState } from "react";
import api from "@/lib/api";

export function useLanguage() {
  const [language, setLanguage] = useState(() => localStorage.getItem("pc_lang") || "en");
  const [languages, setLanguages] = useState([]);
  useEffect(() => { localStorage.setItem("pc_lang", language); }, [language]);
  useEffect(() => { api.get("/languages").then((r) => setLanguages(r.data)).catch((err) => console.warn("[LanguageSelect] request failed", err)); }, []);
  const current = languages.find((l) => l.id === language);
  return { language, setLanguage, languages, current };
}

export function LanguageSelect({ language, setLanguage, languages, testId = "language-select", title = "Content language" }) {
  if (!languages.length) return null;
  return (
    <select value={language} onChange={(e) => setLanguage(e.target.value)} aria-label={title} title={title}
      className="h-10 rounded-full border border-slate-300 bg-white px-3 text-sm font-semibold text-slate-700 hover:border-slate-500 focus:outline-none focus:ring-2 focus:ring-emerald-400"
      data-testid={testId}>
      {languages.map((l) => <option key={l.id} value={l.id}>{l.flag} {l.label}</option>)}
    </select>
  );
}
